'use client';

import { useLayoutEffect } from 'react';
import { gtmClient } from '@/lib/gtm/client';
export type { GtmPurpose } from '@/lib/gtm/client';

export function GoogleTagManager() {
    useLayoutEffect(() => gtmClient.mount(), []);
    return null;
}

export const submitGtmEvent = gtmClient.submit;
export { gtm, type GtmCommonTrackingParams } from '@/lib/gtm/events';
